import { siteRoutes } from "@/routes/siteRoutesList";
import { brand } from "branchAndBrandSpecific/utils/brandVariables/brandVariables";
import {
  Crosshair1Icon,
  GearIcon,
  HeartIcon,
  ReaderIcon,
  MixIcon,
  CardStackIcon,
  StarFilledIcon,
} from "@radix-ui/react-icons";

export const routes = {
  "routes.headlines.main": [
    brand.hasFeature.posts && {
      title: "routes.rout.feed",
      link: siteRoutes["dashboard"],
      logo: CardStackIcon,
    },
  ],
  "routes.headlines.engagement": [
    brand.hasFeature.challenges && {
      title: "routes.route.challenges",
      link: siteRoutes["challenges"],
      logo: Crosshair1Icon,
    },
    brand.hasFeature.teams && {
      title: "routes.route.teams",
      link: siteRoutes["teams"],
      logo: HeartIcon,
    },
  ],
  "routes.headlines.updates": [
    brand.hasFeature.news && {
      title: "routes.route.news",
      link: siteRoutes["news"],
      logo: ReaderIcon,
    },
    brand.hasFeature.schedule && {
      title: "routes.route.schedule",
      link: siteRoutes["schedule"],
      logo: undefined,
    },
    brand.hasFeature.winners && {
      title: "routes.route.winners",
      link: siteRoutes["winners"],
      logo: StarFilledIcon,
    },
  ],
  "routes.headlines.profile": [
    {
      title: "routes.route.settings",
      link: siteRoutes["profileSettings"],
      logo: GearIcon,
    },
  ],
};
